export const onSubmitText = {
    Crear: 'Crear',
    Siguiente: 'Sig.',
    Guardar: 'Guardar',
}